import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-calendar",
  templateUrl: "./med-icon-calendar.component.html",
})
export class MedIconCalendarComponent extends SvgMixinComponent {}
